import { call, put, takeLatest } from "redux-saga/effects";
import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
} from "../../actionTypes/register";
import { doSignUp } from "../../../com/register";
import { RegisterPayload } from "../../action/register";
import { BaseResponse } from "../../response";
import { API_CODES } from "../../../constants";

interface RegisterAction {
  type: typeof REGISTER_USER_REQUEST;
  payload: RegisterPayload;
}

export function* fetchRegister(
  action: RegisterAction,
) {
  try {
    const response: BaseResponse = yield call(doSignUp, action.payload);

    if (response.status === API_CODES.SUCCESS_CODE || response.status === "SUCCESS") {
      yield put({ type: REGISTER_USER_SUCCESS });
    } else {
      yield put({
        type: REGISTER_USER_FAILURE,
        payload: response.statusinfo.message || "Signup failed",
      });
    }
  } catch (err) {
    const error = err as { response?: { data?: { message?: string } } };
    yield put({
      type: REGISTER_USER_FAILURE,
      payload: error.response?.data?.message || "Network error",
    });
  }
}

export function* registerSaga() {
  yield takeLatest(REGISTER_USER_REQUEST, fetchRegister);
}
